import { z } from 'zod/v4';

import { AssemblyIndustry, AssemblyIndustryRuntype } from '../assembly/assemblyBackendTypes';

export type PcbApiSettingsDTO = {
    excluded_industries: AssemblyIndustry[];
};

export const PcbApiSettingsDTORuntype = z.object({
    excluded_industries: z.array(AssemblyIndustryRuntype),
});
